var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useCallback, useState } from 'react';
import { useWatch } from 'react-hook-form';
import { useCreateEventContext } from '../composers/CreateEventContext';
import { useCreateEventSuggestedSpaceQuery } from './useCreateEventSuggestedSpaceQuery';
import { useSuggestedSpaceDetails } from './useSuggestedSpaceDetails';
/**
 * Resolves suggested-space state for create mode: watches invitees, runs the
 * suggested-space query, filters out spaces already on the initial event, and
 * fetches the full space details. Call at the composer wrapper level and pass
 * the resolved {@link Space} into {@link SuggestedSpaceContent}.
 *
 * `suggestedSpace` is `null` until a suggestion has been both selected and
 * fully fetched, so the composer can keep the space section collapsed (no
 * skeleton flash) and silently render nothing if the fetch yields no space.
 *
 * Dismissing is session-scoped: no further suggestions or fetches for the
 * rest of this create composer mount, even if invitees change.
 */
export function useCreateSuggestedSpacePrompt(_a) {
    var _b;
    var levelId = _a.levelId, _c = _a.enabled, enabled = _c === void 0 ? true : _c;
    var _d = __read(useState(false), 2), dismissed = _d[0], setDismissed = _d[1];
    var _e = __read(useWatch({
        name: ['invitees'],
    }), 1), invitees = _e[0];
    var totalInviteesWithUserId = invitees.filter(function (invitee) { return invitee.user_id; }).length;
    var _f = useCreateEventSuggestedSpaceQuery({
        levelId: levelId,
        totalInviteesWithUserId: totalInviteesWithUserId,
        enabled: enabled && !dismissed,
    }), suggestedSpaceId = _f.suggestedSpaceId, loading = _f.loading;
    var initialEvent = useCreateEventContext().initialEvent;
    var resolvedSuggestedSpaceId = dismissed ||
        !enabled ||
        !suggestedSpaceId ||
        ((_b = initialEvent === null || initialEvent === void 0 ? void 0 : initialEvent.spaceIds) === null || _b === void 0 ? void 0 : _b.includes(suggestedSpaceId.toString()))
        ? null
        : suggestedSpaceId;
    var _g = useSuggestedSpaceDetails(resolvedSuggestedSpaceId, dismissed ? false : loading), suggestedSpace = _g.suggestedSpace, fetching = _g.fetching;
    var dismissSuggestedSpace = useCallback(function () {
        setDismissed(true);
    }, []);
    return {
        suggestedSpace: dismissed ? null : suggestedSpace,
        dismissSuggestedSpace: dismissSuggestedSpace,
        loading: dismissed ? false : loading || fetching,
    };
}
